import React from 'react'
import styled from 'styled-components'
import { useRouter } from 'next/router'
import {
  useCmsContentList,
  useContentCategoriesMap,
} from '@sentecacommerce-theme/lib'
import { Pagination } from './Components'
import { BlogItem } from './Components'
import { CategoryExtraFields, Category } from '../../blogPage.props'
import { Loader } from '../../../Common'
import { SeoModule } from '../../../SeoModule'

export const BlogListing = ({
  categoriesList,
  title,
  defaultMetaDescription,
}: {
  categoriesList: Category[]
  title: string
  defaultMetaDescription: string
}) => {
  const categoriesMap = useContentCategoriesMap<CategoryExtraFields>(
    categoriesList
  )
  const router = useRouter()

  const { slug } = router?.query as any

  const { data } = useCmsContentList({
    type: 'Blog',
    tags: categoriesMap[slug] ? [categoriesMap[slug]?.tag] : [],
    limit: 20,
    sort: 'createdAt;1',
  })

  if (!data) {
    return (
      <LoaderContainer style={{ height: 150 * 20 }}>
        <Loader />
      </LoaderContainer>
    )
  }

  const { results, ...rest } = data

  return (
    <>
      <SeoModule title={title} description={defaultMetaDescription} />
      {/* TODO: no result found */}
      {results?.map((content: any) => (
        <BlogItem data={content} key={content?.key} />
      ))}
      <Pagination {...rest} />
    </>
  )
}

const LoaderContainer = styled.div.attrs({
  className: 'd-flex align-items-center justify-content-center',
})`
  min-height: 40rem;
  position: relative;
`
